import type { $Fetch } from 'ofetch';
import { BaseClient } from '@shared/clients/BaseClient.ts';
import type { Logger, Variation } from '@shared/types/types';
import type { AsyncResult } from '@shared/types/utilities';

const DEFAULT_TIMEOUT_MS = 160;

export class CrocotileClient extends BaseClient {
    constructor({
        fetchClient,
        logger,
        baseURL,
        timeout = DEFAULT_TIMEOUT_MS,
    }: {
        fetchClient: $Fetch;
        logger: Logger;
        baseURL?: string;
        timeout?: number;
    }) {
        super(baseURL, fetchClient, logger, timeout);
    }

    async getVariations(variationIds: string[]): AsyncResult<Variation[]> {
        if (!variationIds.length) {
            return { state: 'success', payload: [] };
        }

        const query = { variationIds: variationIds.join(',') };
        const headers: Record<string, string> = { accept: 'application/json', 'crocotile-version': '2' };

        try {
            const payload = await this.fetch<Variation[]>('/crocotile/tile/data', { query, headers });
            return { state: 'success', payload };
        } catch (_err: unknown) {
            return { state: 'error' };
        }
    }

    async getVariation(id: Variation['variationId']): AsyncResult<Variation> {
        const headers: Record<string, string> = { 'crocotile-version': '2' };

        try {
            const payload = await this.fetch<Variation>(`/crocotile/tile/data/${id}`, { headers });
            return { state: 'success', payload };
        } catch (_err: unknown) {
            return { state: 'error' };
        }
    }
}
